var map = {
	"./de/warrior-name.png": "tKnj",
	"./en/warrior-name.png": "7aTV",
	"./es/warrior-name.png": "s7Ed",
	"./fr/warrior-name.png": "7zY7",
	"./ja/warrior-name.png": "q9Yg",
	"./ko/warrior-name.png": "klMx",
	"./pt/warrior-name.png": "1Lf8",
	"./ru/warrior-name.png": "2Ekg",
	"./th/warrior-name.png": "XvoI",
	"./zh-Hant/warrior-name.png": "IazD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jZfp";